import css from "./Forms.module.css"

function Forms(){
    return(
        <div className={css.sectionForm}>

            <div className={css.divform}>
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLScXP6gjQ8V-zAz5QiWzP1J34uqbw3BX9SQqUaRDt2jCTT-Gvw/viewform?embedded=true"
                    width="100%" height="100%" frameBorder="0" marginHeight="0" marginWidth="0">Carregando…
                </iframe>
            </div>

            <div className={css.divformlogo}>
                <img className={css.imgcontato} src="/AnaELu.webp" alt=""/>
            </div>

        </div>
    )
}

export default Forms;
